export default{
    
    service : "https://equalstestingme.mykalyan.company/"+"mepayment/api",
    // service : "http://127.0.0.1:9002/mepayment/api",
    // service : "http://92.168.0.106:9002/mepayment/api", /* loki */
    // service : "http://192.168.0.123:9002/mepayment/api", /* G na smart */
}